var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "m\xE1s") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m\\xE1s"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,47.5 C36.9786916,47.5 47.5,36.9786916 47.5,24 C47.5,11.0213084 36.9786916,0.5 24,0.5 C11.0213084,0.5 0.5,11.0213084 0.5,24 C0.5,36.9786916 11.0213084,47.5 24,47.5 Z",
    id: "Oval-Copy-3",
    stroke: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(12.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    fill: "#5697FA",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-10",
    fill: "#FFFFFF",
    x: 11,
    y: 6,
    width: 2,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-10",
    fill: "#FFFFFF",
    transform: "translate(12.000000, 12.000000) rotate(-270.000000) translate(-12.000000, -12.000000) ",
    x: 11,
    y: 6,
    width: 2,
    height: 12
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewMore);
export default __webpack_public_path__ + "static/media/view-more.9334c9c6c390b02ebef83631f3643299.svg";
export { ForwardRef as ReactComponent };